module.exports = __webpack_public_path__ + "static/media/Compras6.f190e5c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCompras/Compras6.png
// module id = 2072
// module chunks = 0